{
  "name": "City Master",
  "dbName": "city_master",
  "columns": [
    {
      "fieldName": "name",
      "dbName": "name",
      "displayName": "City Name",
      "dataType": "STRING"
    },
    {
      "fieldName": "code",
      "dbName": "code",
      "displayName": "City Code",
      "dataType": "STRING",
      "styleConfig": {
        "type": "badge"
      }
    },
    {
      "fieldName": "stateName",
      "dbName": "state_id",
      "displayName": "State",
      "dataType": "STRING"
    },
    {
      "fieldName": "countryName",
      "dbName": "country_id",
      "displayName": "Country",
      "dataType": "STRING"
    },
    {
      "fieldName": "active",
      "dbName": "active",
      "displayName": "Active",
      "dataType": "BOOLEAN",
      "valueMap": {
        "true": "Active",
        "false": "Inactive"
      },
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "createdDate",
      "displayName": "Created Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "createdBy",
      "displayName": "Created By",
      "dataType": "STRING",
      "hasLookup": true,
      "styleConfig": {
        "type": "user-avatar"
      }
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type" : "user-avatar"
      }
    },
    {
      "fieldName": "modifiedDate",
      "dbName": "modified_date",
      "displayName": "Modified Date",
      "dataType": "DATETIME",
      "sortable": true
    }
  ],

"filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search city by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "city_name"
      }
    ]
  }
}
